import '@splidejs/splide/css'
import '../scss/main.scss'
import Splide from '@splidejs/splide'
import { initResources } from './modules/resources.js'
import { initPartnersCarousel } from './modules/partners.js'
import { initVideoFacade } from './modules/video.js'

document.addEventListener('DOMContentLoaded', () => {
  initResources()
  initVideoFacade()
  initCarousel()
  initPartnersCarousel()
})


// Init carousel on mobile only
let splideInstance = null
function initCarousel() {
    const carousel = document.querySelector('.sdcc-photos__mobile')
    if (!carousel) return
  
    const vw = window.innerWidth
  
    if (vw <= 768) {
      if (!splideInstance) {
        let rightPadding = '60px'
        let slideNum = 1
  
        if(vw <= 350){
          rightPadding = '0px'
        }
        else if(vw <= 400){
          rightPadding = '20px'
        }
        else if(vw <= 435){
          rightPadding = '60px'
        }
        else if(vw <= 500){
          rightPadding = '100px'
        }
        else if (vw <= 535) {
          rightPadding = '160px'
        } else if (vw <= 574) {
          rightPadding = '200px'
        } else if (vw <= 675) {
          rightPadding = '240px'
        } else {
          rightPadding = '0px'
          slideNum = 2
        }
  
        splideInstance = new Splide('.sdcc-photos__mobile', {
          type:         'loop',
          perPage:      slideNum,
          perMove:      1,
          gap:          '16px',
          padding:      { left: '20px', right: rightPadding },
          pagination:   true,
          arrows:       false,
          width:        '100%',
          autoplay:     true,
          interval:     4000,
          pauseOnHover: true,
        }).mount()
      }
    } else {
      if (splideInstance) {
        splideInstance.destroy(true) // true = completely remove generated DOM
        splideInstance = null
      }
    }
  }

  
  document.addEventListener('DOMContentLoaded', initCarousel)

  // Debounced resize handler
  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      initCarousel()
      initPartnersCarousel()
      const section = document.querySelector('.sdcc-resources')
      if (section) {
        if (window.innerWidth >= 768) {
          section.querySelectorAll('.sdcc-resources__divider-row').forEach(divider => {
            divider.classList.remove('sdcc-resources__divider-row--mobile-hidden')
          })
          const visibleRows = [...section.querySelectorAll('.sdcc-resources__row--visible')]
          visibleRows.forEach(row => {
            const prev = row.previousElementSibling
            if (prev && prev.classList.contains('sdcc-resources__divider-row--hidden')) {
              prev.classList.add('sdcc-resources__divider-row--visible')
            }
          })
        } else {
          section.querySelectorAll('.sdcc-resources__divider-row').forEach(divider => {
            divider.classList.add('sdcc-resources__divider-row--mobile-hidden')
          })
        }
      }
    }, 150)
  })

  const setUpSignUpButtons = ()=>{
    const forms = document.querySelectorAll('.sdcc-signup-card__form')
    const emailParam = 'signature[email]'
    const url = 'https://actionnetwork.org/petitions/congress-pass-a-national-data-center-moratorium/?source=?ms=fwws_ot_06092026_NAT-FWW-coalition-homepage&oms=fwws_ot_06092026_NAT-FWW-coalition-homepage'

    forms.forEach((form)=>{
      const btn = form.querySelector('button')
      const input = form.querySelector('input')
      btn.addEventListener('click',()=>{
        window.open(url + '&'  + emailParam + '=' + input.value, '_blank');
      })
    })
  }
  setUpSignUpButtons()
